export const TASK_TYPE = {
  textRequest: 'TEXT_REQUEST',
  fileRequest: 'FILE_REQUEST',
  signatureRequest: 'SIGNATURE_REQUEST',
};

export const TASK_STATUS = {
  new: 'NEW',
  completed: 'COMPLETED',
};
